var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { CustomElement, Component, html, Prop, State, classMap, styleMap, nothing, Interceptor } from '@sick-davinci/ce-decorators';
import { style } from './Balloon.style';
import { IconRef } from './../icon/IconRef';
import { icon_error } from '@sick-davinci/material-icons/alert/error.icon';
import { icon_warning } from '@sick-davinci/material-icons/alert/warning.icon';
import { icon_info } from '@sick-davinci/material-icons/action/info.icon';
export
/**
 * Balloon displays an overlay over a specified element.
 * 
 * @example
 * ```html
 * <davinci-button>Click Me</davinci-button><davinci-balloon position="right" for=":before">Just click the button</davinci-balloon>
 * ```
 * @slot {*} default - content inside balloon
 */
let Balloon = (_dec = Component({
  tag: 'davinci-balloon',
  style: [style],
  dependencies: [IconRef]
}), _dec2 = Prop({
  type: String
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop({
  type: String
}), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop({
  type: String
}), _dec7 = Reflect.metadata("design:type", Object), _dec8 = Prop({
  type: String
}), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop({
  type: String
}), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop({
  type: Boolean
}), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Prop({
  type: Boolean
}), _dec15 = Reflect.metadata("design:type", Boolean), _dec16 = Prop({
  type: String
}), _dec17 = Reflect.metadata("design:type", String), _dec18 = State(), _dec19 = Reflect.metadata("design:type", typeof LayoutInfo === "undefined" ? Object : LayoutInfo), _dec20 = Interceptor('icon'), _dec21 = Reflect.metadata("design:paramtypes", [String, String]), _dec(_class = (_class2 = (_temp = class Balloon extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "position", _descriptor, this);

    _initializerDefineProperty(this, "alignment", _descriptor2, this);

    _initializerDefineProperty(this, "for", _descriptor3, this);

    _initializerDefineProperty(this, "type", _descriptor4, this);

    _initializerDefineProperty(this, "headline", _descriptor5, this);

    _initializerDefineProperty(this, "show", _descriptor6, this);

    _initializerDefineProperty(this, "modal", _descriptor7, this);

    _initializerDefineProperty(this, "icon", _descriptor8, this);

    _initializerDefineProperty(this, "layoutInfo", _descriptor9, this);

    this._animationFrameCallback = null;
  }

  render() {
    return html`<div class="modal">
                  <div class="overlay"></div>
                  <div class=${classMap({
      flex: true,
      top: this.layoutInfo.position === 'top',
      bottom: this.layoutInfo.position === 'bottom',
      right: this.layoutInfo.position === 'right',
      left: this.layoutInfo.position === 'left',
      alignbottom: this.layoutInfo.alignment === 'bottom',
      alignright: this.layoutInfo.alignment === 'right'
    })} style=${styleMap({
      top: this.layoutInfo.top,
      left: this.layoutInfo.left,
      bottom: this.layoutInfo.bottom,
      right: this.layoutInfo.right,
      width: this.layoutInfo.width
    })}>
                    <div class="tip tipShadow" style=${styleMap({
      top: this.layoutInfo.offsetVertical,
      left: this.layoutInfo.offsetHorizontal
    })}></div>
                    <div class="tip" style=${styleMap({
      top: this.layoutInfo.offsetVertical,
      left: this.layoutInfo.offsetHorizontal
    })}></div>
                    <div class="slot">
                      ${this.headline ? html`<div class="headline">
                                                <davinci-icon-ref style="${styleMap({
      display: this.icon ? '' : 'none'
    })}" .src="${this.icon}"></davinci-icon-ref>
                                                <span>${this.headline}</span></div>` : nothing}
                      <slot></slot>
                    </div>
                  </div>
                </div>
                </div>`;
  }

  componentConnected() {
    this._startLayouting();
  }

  componentDisconnected() {
    this._stopLayouting();
  }

  iconIntereptor(_oldvalue, newValue) {
    if (newValue === 'info') {
      return icon_info;
    } else if (newValue === 'warning') {
      return icon_warning;
    } else if (newValue === 'error') {
      return icon_error;
    } else {
      return newValue;
    }
  }

  _startLayouting() {
    this._layoutBalloon();
  }

  _stopLayouting() {
    window.cancelAnimationFrame(this._animationFrameCallback);
    this._animationFrameCallback = null;
  }

  _layoutBalloon() {
    if (this.for && this.show) {
      const element = this.for instanceof Element ? this.for : this.for === ':before' ? this.previousElementSibling : this.for === ':after' ? this.nextElementSibling : document.querySelector('#' + this.for); // boundingRect for bound element

      const {
        top,
        height,
        left,
        width,
        right,
        bottom
      } = element.getBoundingClientRect();
      let computedPosition = {
        position: this.position,
        alignment: this.alignment,
        offsetHorizontal: 0,
        offsetVertical: 0,
        maxHeight: ''
      };
      const layoutInfo = { ...this.layoutInfo
      }; // available space around balloon (2x 12px margin)

      const position = {
        rightSpace: document.documentElement.clientWidth - (left + width) - 40,
        leftSpace: left - 40,
        topSpace: top - 40,
        bottomSpace: document.documentElement.clientHeight - top - height - 40,
        viewportWidth: document.documentElement.clientWidth,
        viewportHeight: document.documentElement.clientHeight
      }; // check for enough space to display balloon, alter the position or alignment if not enough space

      if (this.position === 'top') {
        computedPosition = calcElementAlternatePosition(position, computedPosition, ['top', 'right', 'left', 'bottom']);
      } else if (this.position === 'bottom') {
        computedPosition = calcElementAlternatePosition(position, computedPosition, ['bottom', 'right', 'left', 'top']);
      } else if (this.position === 'left') {
        computedPosition = calcElementAlternatePosition(position, computedPosition, ['left', 'bottom', 'top', 'right']);
      } else if (this.position === 'right') {
        computedPosition = calcElementAlternatePosition(position, computedPosition, ['right', 'bottom', 'top', 'left']);
      } // populate the layoutinfo for render


      layoutInfo.position = computedPosition.position;
      layoutInfo.offsetHorizontal = computedPosition.offsetHorizontal ? computedPosition.offsetHorizontal + 'px' : '';
      layoutInfo.offsetVertical = computedPosition.offsetVertical ? computedPosition.offsetVertical + 'px' : '';
      layoutInfo.maxHeight = computedPosition.maxHeight;
      layoutInfo.alignment = computedPosition.alignment; // determine position 37.5 px is from left+margin to tip middle

      if (computedPosition.position === 'top') {
        layoutInfo.bottom = document.documentElement.clientHeight - top + 'px';
        layoutInfo.top = '';
        layoutInfo.right = computedPosition.alignment === 'right' ? document.documentElement.clientWidth - right + width / 2 - 37.5 - computedPosition.offsetHorizontal + 'px' : '';
        layoutInfo.left = computedPosition.alignment === 'right' ? '' : left + width / 2 - 37.5 - computedPosition.offsetHorizontal + 'px';
      } else if (computedPosition.position === 'bottom') {
        layoutInfo.bottom = '';
        layoutInfo.top = top + height + 'px';
        layoutInfo.right = computedPosition.alignment === 'right' ? document.documentElement.clientWidth - right + width / 2 - 37.5 - computedPosition.offsetHorizontal + 'px' : '';
        layoutInfo.left = computedPosition.alignment === 'right' ? '' : left + width / 2 - 37.5 - computedPosition.offsetHorizontal + 'px';
      } else if (computedPosition.position === 'right') {
        layoutInfo.bottom = computedPosition.alignment === 'bottom' ? document.documentElement.clientHeight - bottom + height / 2 - 37.5 - computedPosition.offsetVertical + 'px' : '';
        layoutInfo.top = computedPosition.alignment === 'bottom' ? '' : top + height / 2 - 37.5 + computedPosition.offsetVertical + 'px';
        layoutInfo.right = '';
        layoutInfo.left = left + width + 'px';
      } else if (computedPosition.position === 'left') {
        layoutInfo.bottom = computedPosition.alignment === 'bottom' ? document.documentElement.clientHeight - bottom + height / 2 - 37.5 - computedPosition.offsetVertical + 'px' : '';
        layoutInfo.top = computedPosition.alignment === 'bottom' ? '' : top + height / 2 - 37.5 + computedPosition.offsetVertical + 'px';
        layoutInfo.right = document.documentElement.clientWidth - left + 'px';
        layoutInfo.left = '';
      }

      this.layoutInfo = layoutInfo;
    }

    this._animationFrameCallback = window.requestAnimationFrame(() => {
      Promise.resolve().then(() => {
        this._layoutBalloon();
      });
    });
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "position", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'top';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "alignment", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'top';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "for", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'default';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "headline", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "show", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "modal", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "layoutInfo", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      top: '',
      bottom: '',
      left: '',
      right: '',
      offsetVertical: '',
      offsetHorizontal: '',
      position: 'top',
      alignment: 'top',
      maxHeight: '',
      width: ''
    };
  }
}), _applyDecoratedDescriptor(_class2.prototype, "iconIntereptor", [_dec20, _dec21], Object.getOwnPropertyDescriptor(_class2.prototype, "iconIntereptor"), _class2.prototype)), _class2)) || _class);

function calcElementAlternatePosition(position, computedPosition, priority) {
  if (priority.length === 0) {
    return computedPosition;
  }

  if (priority[0] === 'top') {
    if (position.topSpace < 200) {
      priority.splice(0, 1);
      return calcElementAlternatePosition(position, computedPosition, priority);
    } else {
      if (position.rightSpace < 200 && position.leftSpace > position.rightSpace) {
        return {
          position: 'top',
          offsetHorizontal: 0,
          offsetVertical: 0,
          maxHeight: '',
          alignment: 'right'
        };
      } else {
        return {
          position: 'top',
          offsetHorizontal: 0,
          offsetVertical: 0,
          maxHeight: '',
          alignment: 'left'
        };
      }
    }
  } else if (priority[0] === 'bottom') {
    if (position.bottomSpace < 200) {
      priority.splice(0, 1);
      return calcElementAlternatePosition(position, computedPosition, priority);
    } else {
      if (position.rightSpace < 200 && position.leftSpace > position.rightSpace) {
        return {
          position: 'bottom',
          offsetHorizontal: 0,
          offsetVertical: 0,
          maxHeight: '',
          alignment: 'right'
        };
      } else {
        return {
          position: 'bottom',
          offsetHorizontal: 0,
          offsetVertical: 0,
          maxHeight: '',
          alignment: 'left'
        };
      }
    }
  } else if (priority[0] === 'left') {
    if (position.leftSpace < 200) {
      priority.splice(0, 1);
      return calcElementAlternatePosition(position, computedPosition, priority);
    } else {
      if (position.topSpace < position.bottomSpace) {
        return {
          position: 'left',
          offsetHorizontal: 0,
          offsetVertical: 0,
          maxHeight: '',
          alignment: 'top'
        };
      } else {
        return {
          position: 'left',
          offsetHorizontal: 0,
          offsetVertical: 0,
          maxHeight: '',
          alignment: 'bottom'
        };
      }
    }
  } else if (priority[0] === 'right') {
    if (position.rightSpace < 200) {
      priority.splice(0, 1);
      return calcElementAlternatePosition(position, computedPosition, priority);
    } else {
      if (position.topSpace < position.bottomSpace) {
        return {
          position: 'right',
          offsetHorizontal: 0,
          offsetVertical: 0,
          maxHeight: '',
          alignment: 'top'
        };
      } else {
        return {
          position: 'right',
          offsetHorizontal: 0,
          offsetVertical: 0,
          maxHeight: '',
          alignment: 'bottom'
        };
      }
    }
  } else {
    return null; // should never happen
  }
}
//# sourceMappingURL=Balloon.js.map